export default __webpack_public_path__ + "7760233f702937306cc863e1f937dbe9.svg";